import {Component, Output, OnInit, EventEmitter, Input} from '@angular/core';
import {GameSetUpService} from "../../providers/gameSetUp.service";



@Component({
    selector: 'scaling-component',
    templateUrl: './scaling.component.html',
    styleUrls: ['./scaling.component.scss']
})
export class ScaleComponent implements OnInit {

    private zoomMax: number = 1;
    private zoomMin: number = 0.5;
    private zoomStepSize: number = 0.1;
    private scale = 1;
    
    constructor() {
    }

    ngOnInit() {
        document.querySelector("meta[name=viewport]").setAttribute(
            'content',
            'width=device-width, initial-scale='+this.scale+', shrink-to-fit=no');
    }

    ngAfterViewInit() {
        // setTimeout(_ => /*code*/ );
    }


    zoomIn(){

        if(this.scale < this.zoomMax){
            this.scale = this.scale + this.zoomStepSize;

            document.querySelector("meta[name=viewport]").setAttribute(
                'content',
                'width=device-width, initial-scale='+this.scale+', shrink-to-fit=no');
        }

    }
    
    zoomOut(){
        if(this.scale > this.zoomMin){
            this.scale = this.scale - this.zoomStepSize;

            document.querySelector("meta[name=viewport]").setAttribute(
                'content',
                'width=device-width, initial-scale='+this.scale+', shrink-to-fit=no');
        }
    }
    





}



// WEBPACK FOOTER //
// ./src/app/components/scaling/scaling.component.ts